@use '../../styling/buttons.scss' as *;

.Button {
  @extend %button;
}
